import React from 'react';
import { Provider } from 'react-redux';
import { Link, Outlet } from "react-router-dom";
import { Container, Divider, Grid, GridRow, GridColumn, Header, Menu , Image} from "semantic-ui-react";
import VersionInfo from "../components/VersionInfo";
import 'semantic-ui-css/semantic.min.css'
import payairLogo from "./img/payairSmallLogo.svg"

import store, { saveToLocalStorage } from '../store/SrciStore';
import { debounce } from 'lodash';
import RequestPayload from '../components/RequestPayload';

store.subscribe(
  debounce(() => {
    saveToLocalStorage(store.getState())
  }, 500)
)

export default function DefaultLayout() {
  return (
    <Provider store={store}>
      <Container>
      <Divider hidden />
      <Grid>
        <GridRow>
          <GridColumn width={16}>
            <Link to="/">
              <Header size="huge">
                <Image src={payairLogo} />
                <Header.Content>
                  Payair DemoShop
                  <Header.Subheader>Test platform of C2P</Header.Subheader>
                </Header.Content>
              </Header>
            </Link>

            <Menu>
              <Link to="/cart"><Menu.Item name="Cart" icon="shopping cart" /></Link>
              <Link to="/config"><Menu.Item name="Config" icon="wrench" /></Link>
            </Menu>
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn width={16}>
            <Outlet/>
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn width={16}>
            <Divider />
            <VersionInfo />
            <Divider hidden />
            <RequestPayload />
          </GridColumn>
        </GridRow>
      </Grid>
    </Container>   
  </Provider>  
  )
}